import DetailsPanelRow from './DetailsPanelRow';

export { DetailsPanelRow };
export default DetailsPanelRow;
